import React from 'react'
import { Box } from '@mui/material'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

function normalizeMarkdown(text: string): string {
  return text.replace(/([.!?:])\s*(#{1,6}\s)/g, '$1\n\n$2')
}

export default function MarkdownBlock({ text }: { text: string }) {
  return (
    <Box
      data-testid="ca-markdown"
      sx={{
        fontSize: '0.875rem',
        lineHeight: 1.5,
        wordBreak: 'break-word',
        '& > :first-of-type': { mt: 0 },
        '& > :last-child': { mb: 0 },
        '& p': { my: 0.5 },
        '& ul, & ol': { my: 0.5, pl: 2.5 },
        '& code': {
          px: 0.5,
          py: 0.125,
          borderRadius: 0.5,
          bgcolor: 'action.hover',
          fontSize: '0.8125rem',
        },
        '& pre': { p: 1, borderRadius: 1, bgcolor: 'action.hover', overflowX: 'auto' },
        '& pre code': { p: 0, bgcolor: 'transparent' },
        '& a': { color: 'primary.main' },
        '& table': { borderCollapse: 'collapse' },
        '& th, & td': { border: '1px solid', borderColor: 'divider', px: 1, py: 0.5 },
      }}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{normalizeMarkdown(text)}</ReactMarkdown>
    </Box>
  )
}
